import React, { Component } from 'react';
import { ErrorBox } from '../components/ErrorBox.tsx';
import { PreviousButton } from '../components/PreviousButton.tsx';
import { NextButton } from '../components/NextButton.tsx';
import { LenderRow } from '../components/LenderRow';
import { NumberInput } from '../components/NumberInput.tsx';
import { TextInput } from '../components/TextInput.tsx';

interface IProps {
    gtmEvent(): void;
    prevStep(): void;
    nextStep(): void;
    applicant?: number;
    lvemploymenttype?: string;
    updateLead(props: any): void;
    consent: boolean; 
    applicationType: string;
    lvfulltimepermanent?:string;
    lvprobationpassed?:string;
    lvhowlongtrading?:string;
    lvovertime?:number;
    lvshiftallowance?:number;
    lvpropertyvalue?:number;
    lvretainexistingproperty?:string;
    lvequityfromsale?:number;    
    lvmortgageoutstanding?:number;
    lvtermremaining?:string;
    lvinterestrate?:number;
    lvmonthlyrent?:number;
}

interface IState {
    hasError: boolean;
    errors?: string[];
    lvemploymenttype?: string;
    partnerSmoker?: boolean;    
    lvfulltimepermanent?:string;
    lvprobationpassed?:string;
    lvhowlongtrading?:string;
    lvovertime?:number;
    lvshiftallowance?:number;
    lvpropertyvalue?:number;
    lvequityfromsale?:number;    
    lvmortgageoutstanding?:number;
    lvtermremaining?:number;
    lvinterestrate?:number;
    lvmonthlyrent?:number;
}

export class LVExistingPropertyDetails extends Component<IProps, IState> {
    
    constructor (props: IProps) {
        super(props);
        this.state = {
            hasError: false, 
            lvemploymenttype: this.props.lvemploymenttype,            
            lvfulltimepermanent: this.props.lvfulltimepermanent,
            lvprobationpassed: this.props.lvprobationpassed
        };
    }

    componentDidMount(): void {
        this.props.gtmEvent();
    }

    CaptureFullTime(option:string){
        this.setState({lvfulltimepermanent:option, hasError:false});
        this.props.updateLead({lvfulltimepermanent:option});
    }

    CaptureProbationPassed(option:string){
        this.setState({lvprobationpassed:option, hasError:false});
        this.props.updateLead({lvprobationpassed:option});
    }

    nextStep() {
    /*const errors: string[] = [];    

    if(this.state.lvemploymenttype=="paye" && (!this.state.lvfulltimepermanent || !this.state.lvprobationpassed)){
        errors.push('Please select a response ?');        
    }

    if(this.state.lvemploymenttype=="selfemployed" && !this.state.lvhowlongtrading){
        errors.push('Please select a response ?');        
    }

    if (errors.length > 0) {
        this.setState({ hasError: true, errors });
        return;
    }

    this.setState({ hasError: false, errors: [] });*/
    this.props.nextStep()
    }
    
    render() {
        const{lvemploymenttype,lvfulltimepermanent,lvprobationpassed,hasError,errors}=this.state;       
        return (            
            <header className="App-header">
                <div className='wrapper'>
                    <h1 className='l'>Existing Property Details</h1><br/>
                    {/* <h2 className='l'> <span className='doddltext'>Probation Passed?</span></h2> */}
                    {this.props.lvretainexistingproperty === 'false' && (<>
                        <div className='column2 justify-e'>
                            <NumberInput
                                id='lvequityfromsale'
                                key='lvequityfromsale'
                                label={<>Equity available from sale? </>}
                                value={this.props.lvequityfromsale}
                                classes={this.state.hasError && !this.state.lvequityfromsale ? "e" : ""}
                                onChange={(e) => { this.setState({lvequityfromsale: e.target.value}); this.props.updateLead({lvequityfromsale:e.target.value}); }} />
                        </div>
                    </>)}
                    {this.props.lvretainexistingproperty === 'true' && (<>                        
                        <div className='column2 justify-s'>
                            <NumberInput
                                id='lvpropertyvalue'
                                key='lvpropertyvalue'
                                label={<>Property Value</>}
                                value={this.props.lvpropertyvalue}
                                classes={this.state.hasError && !this.state.lvpropertyvalue ? "e" : ""}
                                onChange={(e) => { this.setState({lvpropertyvalue: e.target.value}); this.props.updateLead({lvpropertyvalue:e.target.value}); }} />
                        </div>
                        <div className='column2 justify-s'>
                            <NumberInput
                                id='lvmortgageoutstanding'
                                key='lvmortgageoutstanding'
                                label={<>Mortgage Outstanding</>}
                                value={this.props.lvmortgageoutstanding}
                                classes={this.state.hasError && !this.state.lvmortgageoutstanding ? "e" : ""}
                                onChange={(e) => { this.setState({lvmortgageoutstanding: e.target.value}); this.props.updateLead({lvmortgageoutstanding:e.target.value}); }} />
                        </div>
                        <div className='column2 justify-c'></div> <div className='column2 justify-c'></div>
                        <div className='column2 justify-c'>
                            <TextInput
                                id='lvtermremaining'
                                value={this.props.lvtermremaining}
                                placeholder=''
                                label={<>Term Remaining</>}
                                classes={this.state.hasError && !this.state.lvtermremaining ? "e" : ""}
                                onChange={(e) => { this.setState({lvtermremaining: e.target.value}); this.props.updateLead({lvtermremaining:e.target.value}); }} />
                        </div> 
                        <div className='column2 justify-c'>
                            <NumberInput
                                id='lvinterestrate'
                                type='percentage'
                                value={this.props.lvinterestrate}
                                label={<>Interest Rate</>}
                                classes={this.state.hasError && !this.state.lvinterestrate ? "e" : ""}
                                onChange={(e) => { this.setState({lvinterestrate: e.target.value}); this.props.updateLead({lvinterestrate:e.target.value}); }} />
                        </div>
                        <div className='column2 justify-c'></div> <div className='column2 justify-c'></div>
                        <div className='column2 justify-s'>
                            <NumberInput
                                id='lvmonthlyrent'
                                key='lvmonthlyrent'
                                label={<>Expected rent per month</>}
                                value={this.props.lvmonthlyrent}
                                classes={this.state.hasError && !this.state.lvmonthlyrent ? "e" : ""}
                                onChange={(e) => { this.setState({lvmonthlyrent: e.target.value}); this.props.updateLead({lvmonthlyrent:e.target.value}); }} />
                        </div>
                    </>)}

                    {hasError &&
                        <ErrorBox errors={errors!} />
                    }
                    <div className='row'>
                        <div className='button-group'>
                            <PreviousButton onClick={() => this.props.prevStep()} />
                            <NextButton customLabel='Next' onClick={() => this.nextStep()} />
                        </div>
                    </div>
                    <div className='row mt-2'>
                        <LenderRow />
                    </div>
                </div>
            </header>
        );
    }
}